// extracted by mini-css-extract-plugin
module.exports = {"root":"_2xV8h","col-4":"_1L_Zm","light":"_1eIAK","dark":"_38zQH","bordered":"Xb_er","col-3":"_3tcbX"};